import { gql } from '@apollo/client';
const REMOVE_MODEL_SPECIFICATION = gql `
  mutation RemoveModelSpecification($modelSpecificationId: ID!) {
    removeModelSpecification(modelSpecificationId: $modelSpecificationId) {
      removed
    }
  }
`;
export default REMOVE_MODEL_SPECIFICATION;
